/**
 * The re-run opener for Compare surfaces, the one dialog that takes a past
 * run's values. Shared by `useOpenAnalysisRerun` (Analyses hub) and
 * `StationVolumeDock` (dock re-run), so the candidate pool and the shell
 * class cannot drift between entry points.
 *
 * Deliberately NOT in `openAnalysisDialogs.tsx`: that module imports every
 * analysis dialog (LandXML export pulls in the IFC viewer), which the dock
 * has no business loading.
 */
import { RunCompareSurfacesDialog } from '@/components/RunCompareSurfacesDialog';
import { ANALYSIS_DIALOG_OPTIONS, COMPARE_SHELL_CLASS } from '@/lib/analysisDialog';

import { isCompareCandidate } from './candidates';
import type { OpenerEnv } from './openAnalysisDialogs';
import type { CompareRerunPlan } from './rerun';

/** Re-run of a past deviation, surface difference or pair: the plan's values,
 *  station section and notice. The WHOLE pool goes in — the dialog keeps the
 *  picked A out of B's list itself (D10), so switching a side can still pick
 *  the original layer. */
export function openCompareSurfacesRerun(
  env: OpenerEnv,
  plan: Pick<CompareRerunPlan, 'initialValues' | 'initialStationParams' | 'rerunNotice'>,
): void {
  env.openDialog(
    <RunCompareSurfacesDialog
      projectId={env.projectId}
      candidateLayers={env.layers.filter(isCompareCandidate)}
      initialValues={plan.initialValues}
      initialStationParams={plan.initialStationParams}
      rerunNotice={plan.rerunNotice}
    />,
    COMPARE_SHELL_CLASS,
    ANALYSIS_DIALOG_OPTIONS,
  );
}
